export default {
    "navigation": {
        "allWatchfaces": "Todas las apps",
        "faq": "FAQ",
        "helpCenter": "Ayuda e instrucciones",
        "newsletter": "Newsletter",
        "contact": "Contacto",
        "weatherProvider": "Proveedor del Clima",
        "tides": "Mareas",
        "colors": "Colores",
        "fonts": "Fuentes"
    },
    "homepage": {
        "title": "TitanicTurtle Apps",
        "subtitle": "Apps Garmin modernas con funciones avanzadas para todas tus actividades",
        "newBadge": "Nuevo",
        "filter": {
            "label": "Product filter",
            "watchfaces": "Watchfaces",
            "apps": "Apps",
            "all": "All",
            "noProducts": "No products in this category"
        }
    },
    "faq": {
        "title": "Preguntas frecuentes",
        "subtitle": "Encuentra respuestas a preguntas comunes sobre nuestras caras de reloj",
        "tabs": {
            "search": "Buscar",
            "categories": "Categorías",
            "trending": "Tendencias"
        },
        "search": {
            "placeholder": "Buscar ayuda...",
            "button": "Buscar",
            "suggestions": "Búsquedas populares",
            "tips": {
                "title": "Consejos de búsqueda",
                "keywords": "Usa palabras clave específicas como \"GPS\", \"clima\" o \"configuración\"",
                "language": "La búsqueda funciona en tu idioma seleccionado",
                "categories": "Navega por categorías para ayuda organizada"
            }
        },
        "noResults": {
            "title": "No se encontraron resultados",
            "description": "Prueba diferentes palabras clave o navega por categorías",
            "browseCategories": "Navegar por categorías"
        },
        "suggestions": {
            "title": "Búsquedas populares"
        },
        "trending": {
            "title": "Búsquedas tendencia"
        },
        "categories": {
            "title": "Navegar por categoría",
            "items": "elementos",
            "allItems": "Todos los elementos FAQ",
            "allItemsDescription": "Navega todas las preguntas frecuentes",
            "noItems": {
                "title": "No hay elementos en esta categoría",
                "description": "Intenta seleccionar una categoría diferente"
            },
            "viewMore": "Ver todos los elementos"
        },
        "results": {
            "title": "Resultados de búsqueda",
            "found": "resultados encontrados para",
            "total": "Total de resultados",
            "bestMatch": "Mejor coincidencia",
            "categories": "Categorías",
            "sortBy": "Ordenar por",
            "sort": {
                "relevance": "Relevancia",
                "priority": "Prioridad",
                "category": "Categoría"
            },
            "lastUpdated": "Última actualización",
            "matchedIn": "Coincidencia en",
            "footer": "¿No encontraste lo que buscabas?",
            "browseCategories": "Navegar por categorías",
            "viewTrending": "Ver tendencias",
            "contactSupport": "Contactar soporte"
        },
        "actions": {
            "copy": "Copiar",
            "share": "Compartir",
            "copyAnswer": "Copiar respuesta",
            "copyAll": "Copiar todo"
        },
        "loading": "Cargando FAQ...",
        "error": "Error de carga",
        "retry": "Intentar de nuevo"
    },
    "guides": {
        "backToHelp": "Atrás",
        "purchase": {
            "title": "Compra e instalación",
            "tabs": { "installation": "Instalación", "versions": "VX / Elite", "troubleshooting": "Solución de problemas" },
            "installation": {
                "title": "Instalar watchfaces con la app ConnectIQ",
                "intro": "Los watchfaces se instalan en el reloj mediante la app Garmin ConnectIQ (Android o iOS).",
                "step1": "Conecta el reloj al teléfono por Bluetooth y abre la app ConnectIQ.",
                "step2": "Ve a la página del watchface que quieras instalar.",
                "step3": "Pulsa \"Instalar\". El watchface se pondrá en cola y se instalará en el reloj.",
                "step4": "Tras la instalación verás un mensaje y el watchface estará disponible en el dispositivo.",
                "noteScreen": "No apagues la pantalla del teléfono y mantén la app ConnectIQ abierta durante la instalación y actualizaciones.",
                "selectWatchfaceTitle": "Seleccionar el watchface en el reloj",
                "selectWatchfaceIntro": "Si el watchface está instalado pero no se ve, selecciónalo en el menú del sistema del reloj.",
                "select1": "Mantén pulsado el botón de menú (o el equivalente en táctiles) para abrir el menú del sistema.",
                "select2": "Ve a \"Caras de reloj\" o \"Diseños de pantalla\".",
                "select3": "Verás la lista de watchfaces instalados. Usa las teclas arriba/abajo o la pantalla táctil.",
                "select4": "Confirma con el botón superior derecho. El watchface quedará activo."
            },
            "versions": {
                "title": "VX frente a Elite – ¿qué diferencia hay?",
                "sameFeatures": "Ambas versiones son idénticas en funciones. Solo cambian la compra y la activación.",
                "eliteTitle": "Versión Elite (Garmin Pay)",
                "elite1": "Instalación separada, comprada con Garmin Pay en ConnectIQ Store.",
                "elite2": "La versión Elite está vinculada a tu cuenta Garmin. Con un reloj nuevo puedes reinstalarla sin otro código.",
                "elite3": "Garmin Pay no está disponible en todos los modelos ni en todos los países.",
                "eliteNoKey": "Importante: al comprar una versión Elite con Garmin Pay no se envía código de desbloqueo. La Elite se desbloquea al instante.",
                "vxTitle": "Versión VX / Web",
                "vx1": "Compatible con más dispositivos; suele estar disponible cuando Garmin Pay no.",
                "vx2": "Incluye período de prueba de varios días.",
                "vx3": "Después puedes comprar un código en esta web para desbloquear la VX (o las funciones Pro).",
                "vx4": "El código solo es válido para el dispositivo (WatchfaceID) para el que se compró.",
                "vx5": "Si Garmin te cambia el reloj en garantía, se puede generar un código nuevo. Contáctanos por el formulario."
            },
            "website": {
                "title": "Compra por la web (VX / versiones normales)",
                "step1": "Instala primero el watchface en el reloj (ver pestaña Instalación). La WatchfaceID solo aparece en ajustes tras la instalación.",
                "step2": "Abre los ajustes del watchface (app ConnectIQ o Garmin Express) y copia la WatchfaceID del campo superior.",
                "step3": "En esta web elige el watchface e introduce tu WatchfaceID en el formulario de compra.",
                "step4": "Completa el pago. Recibirás el código por correo para introducirlo en los ajustes del watchface.",
                "noteNoAutoInstall": "Importante: comprar un código en la web no instala el watchface. Haz la instalación manualmente."
            },
            "troubleshooting": {
                "installationTitle": "Problemas de instalación (cola / actualizaciones atascadas)",
                "installationIntro": "A veces la instalación falla, el watchface se queda en cola o la app muestra actualizaciones sin fin.",
                "installationCause": "Suele deberse a la app ConnectIQ o a los servicios Garmin, no al watchface.",
                "installationFix1": "Reinicia el reloj y la app ConnectIQ en el teléfono.",
                "installationFix2": "Vuelve a intentar la instalación y mantén la pantalla y la app abiertas.",
                "garminPayTitle": "Compra con Garmin Pay atascada \"en curso\"",
                "garminPayText": "Si una compra con Garmin Pay queda mucho tiempo \"en curso\", es competencia de Garmin. Contacta con el soporte oficial de Garmin.",
                "noKeyTitle": "No he recibido el código tras comprar en la web",
                "noKey1": "Revisa primero la carpeta de spam. Los correos con claves suelen ir ahí.",
                "noKey2": "A menudo un error en el correo impide la entrega. Contáctanos con el correo usado y si es posible la WatchfaceID.",
                "noKey3": " e indica el correo usado en el pago y si puedes la WatchfaceID.",
                "noKeyElite": "Si compraste una versión Elite con Garmin Pay en ConnectIQ Store no se envía código. La Elite se desbloquea al instante."
            },
            "contactLink": "Formulario de contacto"
        },
        "timezones": {
            "title": "Zonas horarias y desplazamiento UTC",
            "basicsTitle": "¿Qué son la 2.ª y 3.ª zona horaria?",
            "basicsText": "En muchos watchfaces puedes configurar dos zonas horarias más (suelen llamarse \"segunda\" y \"tercera\" zona).",
            "offsetTitle": "Configurar los desplazamientos UTC",
            "offsetIntro": "En los ajustes suele haber un campo para el desplazamiento de la 2.ª y 3.ª zona en minutos respecto a UTC.",
            "offsetFormat": "El primer valor es la 2.ª zona, el segundo la 3.ª, en minutos separados por un espacio. No se añade + para positivos.",
            "exampleLabel": "Ejemplo:",
            "exampleExplanation": "Aquí la 2.ª zona tendría -4,5 h (−270 min) y la 3.ª +2 h (+120 min) respecto a UTC.",
            "changeExample": "Para una 2.ª zona a +6 h el primer valor debe ser 360 (6×60). Ejemplo: 360 120",
            "advancedTitle": "Opciones avanzadas (sufijo A/B/C)",
            "advancedOptionalHint": "Esta sección es opcional. Solo aplica si tu watchface admite los sufijos A/B/C.",
            "advancedIntro": "Si tu watchface admite estos sufijos lo indica la descripción encima del campo de desplazamiento en los ajustes del watchface. Si es así, verás una descripción similar a:",
            "advancedExample": "Desplazamiento UTC 2.ª y 3.ª zona en minutos (separar con espacio) (letras: A = 12h, B = 24h, C = militar, vacío = estándar)",
            "advancedNote": "Las letras opcionales A/B/C controlan el formato de hora en algunos watchfaces. Úsalas solo si el watchface lo indica.",
            "exampleSectionTitle": "Paso a paso: Ejemplo para distintas ciudades y formatos",
            "exampleIntro": "Este ejemplo muestra cómo configurar una 2.ª zona (p. ej. Nueva York) y una 3.ª (p. ej. Tokio), y opcionalmente 12h o 24h para cada una.",
            "exampleStep1Title": "Paso 1: Desplazamiento UTC para la 2.ª zona",
            "exampleStep1Text": "Elige la ciudad o región para la 2.ª zona. Pasa su diferencia con UTC a minutos. Ej.: Nueva York (EST, UTC−5) → −300 minutos. Introduce este valor primero en el campo.",
            "exampleStep2Title": "Paso 2: Desplazamiento UTC para la 3.ª zona",
            "exampleStep2Text": "Lo mismo para la 3.ª zona. Ej.: Tokio (JST, UTC+9) → 540 minutos. Es el segundo valor, separado por un espacio del primero.",
            "exampleOnlyOffsets": "Si tu watchface no usa sufijos A/B/C, ya está. Introduce:",
            "exampleStep3Title": "Paso 3: Sufijo de formato opcional (A/B/C)",
            "exampleStep3Optional": "Este paso es opcional: puedes no usar sufijos aunque el watchface los admita; entonces se usa el formato por defecto. Para forzar 12h, 24h o militar por zona, añade la letra justo detrás del desplazamiento, sin espacio.",
            "exampleStep3Text": "Ejemplo: formato 12h para Nueva York (A) y 24h para Tokio (B):",
            "exampleStep3Note": "Sin sufijo = formato por defecto del watchface (a menudo 24h). Si los sufijos están admitidos lo indica la descripción encima del campo de desplazamiento en los ajustes.",
            "exampleFormatTitle": "Cómo se muestra la hora con A, B, C",
            "exampleFormatIntro": "Para el mismo instante, la pantalla varía según el formato (ej.: 2.ª zona Nueva York -300, 3.ª zona Tokio 540). Vista previa en directo:",
            "zone2": "2.ª zona",
            "zone3": "3.ª zona",
            "exampleTableTitle": "Referencia: Desplazamientos UTC de algunas ciudades (minutos)",
            "exampleTableIntro": "Hora estándar; el horario de verano puede variar. Multiplica las horas por 60."
        },
        "switchViews": {
            "title": "Switchviews y gestos",
            "wordLabel": "vista alternativa",
            "basicsTitle": "¿Qué son los Switchviews?",
            "basicsText": "Muchos watchfaces muestran otra información en la misma zona. Esas vistas suelen llamarse \"Switchview\" ({{wordLabel}}), \"Switchview 2\", \"Top View 1/2\", \"Bottom View 1/2\" en los ajustes.",
            "proNote": "Suelen ser funciones Pro con periodo de prueba y luego requieren clave.",
            "gestureTitle": "Cambiar vista con un gesto de muñeca",
            "gestureIntro": "Sin pantalla táctil compatible, las vistas se cambian con un segundo gesto de muñeca.",
            "gestureStep1": "Levanta la muñeca como de costumbre para despertar la pantalla (segundos o pantalla encendida).",
            "gestureStep2": "En unos segundos (unos 7) repite el gesto, sin brusquedad pero claro.",
            "gestureStep3": "Si el watchface usa Switchviews, las zonas configuradas pasan a la siguiente vista.",
            "gestureHint": "Si no cambia nada, revisa los ajustes: algunas vistas hay que asignarlas (ej. \"Top View 2\" / \"Bottom View 2\").",
            "touchTitle": "Switchviews en dispositivos táctiles",
            "touchIntro": "En relojes con pantalla táctil (ej. Fenix 7 y posteriores) las vistas también se cambian tocando zonas concretas.",
            "touchConfig": "En los ajustes, a menudo más abajo, puedes configurar esas zonas (dígitos de hora/minuto o áreas).",
            "touchHold": "Un toque largo en la zona configurada cambia la vista asignada.",
            "touchMultiple": "Algunos watchfaces tienen varias zonas (ej. una para la vista superior y otra para la inferior).",
            "touchInfo": "Las zonas especiales suelen describirse en la ficha del watchface en esta web o en ConnectIQ Store."
        },
        "findWfId": {
            "title": "Cómo encontrar tu WatchfaceID",
            "whatIs": "¿Qué es la WatchfaceID?",
            "whatIsExplanation": "Cada watchface tiene una WatchfaceID por dispositivo (número de 5–6 cifras). Sirve para comprar un código de activación o para soporte.",
            "connectIqTitle": "Con la app ConnectIQ (recomendado)",
            "ciq1": "Comprueba que el reloj esté conectado al teléfono por Bluetooth.",
            "ciq2": "Abre la app ConnectIQ.",
            "ciq3": "Ve a la página del watchface (descripción e imágenes). Si no la encuentras, usa la búsqueda o \"Mis caras de reloj\" en \"Dispositivo\".",
            "ciq4": "Pulsa \"Ajustes\" en la página del watchface.",
            "ciq5": "La WatchfaceID está en el campo superior. Copia ese número; es el ID para el pago.",
            "keyEntryTitle": "Introducir el código de activación",
            "keyEntryExplanation": "Debajo del campo WatchfaceID está el campo para el código que se envía tras el pago. Algunos watchfaces muestran ahí los días de prueba; bórralo antes de poner el código.",
            "garminExpressTitle": "Con Garmin Express (ordenador)",
            "ge1": "Instala Garmin Express y conecta el reloj.",
            "ge2": "Abre la lista de watchfaces instalados.",
            "ge3": "Pulsa los tres puntos junto al watchface para abrir los ajustes.",
            "ge4": "Mismos pasos que con la app ConnectIQ.",
            "geNote": "Se recomienda la app ConnectIQ; algunas versiones de Garmin Express dan problemas.",
            "zeroId": "¿WatchfaceID muestra 0?",
            "zeroIdExplanation": "A veces la WatchfaceID aparece como 0. Guarda los ajustes una vez o reinicia el reloj. Si sigue en 0, el pago suele funcionar igual."
        },
        "location": {
            "title": "GPS y ubicación",
            "whatIsGpsFix": "¿Qué es un fix GPS?",
            "gpsFixExplanation": "Un fix GPS indica al watchface tu posición para calcular salida/puesta de sol, fases lunares, clima y mareas.",
            "howTo": "Hacer un fix GPS",
            "step1": "En el reloj, ve a la pantalla de inicio de una actividad (ej. \"Correr\").",
            "step2": "Espera a que el reloj tenga señal GPS (barra/icono verde).",
            "step3": "Vuelve al watchface; los datos se actualizarán en unos minutos.",
            "alternative": "Alternativa: GPS del teléfono",
            "alternativeExplanation": "Puedes activar el GPS del teléfono. El reloj debe estar conectado por Bluetooth. Es más lento pero igual de válido.",
            "requirements": "Requisitos",
            "req1": "Reloj conectado al teléfono por Bluetooth",
            "req2": "App Garmin Connect (no Connect IQ) al menos en segundo plano",
            "req3": "GPS activado en el teléfono si usas la ubicación del teléfono"
        },
        "settings": {
            "tabs": { "options": "Opciones de campos de datos", "change": "Cambiar ajustes", "troubleshoot": "Solución de problemas" },
            "title": "Ajustes del watchface",
            "optionsIntro": "Lista general de opciones de campos de datos. Haz clic para ver la descripción. No todas las opciones están disponibles en todos los watchfaces.",
            "change": {
                "title": "Cómo cambiar los ajustes del watchface",
                "intro": "Los ajustes del watchface se cambian desde la app ConnectIQ en el teléfono.",
                "step1": "Conecta el reloj al teléfono por Bluetooth y abre la app ConnectIQ (no la app Connect).",
                "step2": "Ve a la página del watchface. Si no está instalado, instálalo primero.",
                "step3": "En la página del watchface verás el botón «Ajustes»; tócalo para abrir la lista de ajustes.",
                "step4": "Aquí puedes cambiar todos los campos de datos, colores y opciones avanzadas.",
                "step5": "Toca el botón de guardar arriba a la derecha para transferir los ajustes al reloj.",
                "installLink": "Guía de instalación"
            },
            "troubleshoot": {
                "title": "Solución de problemas",
                "cantSave": { "q": "No se pueden guardar los ajustes", "a1": "A veces los servidores de Garmin tienen problemas con ciertos caracteres.", "a2": "Vacía el campo del tema de color (si existe) y guarda de nuevo." },
                "wontOpen": { "q": "Los ajustes no se abren", "a1": "Cierra por completo la app ConnectIQ y reinicia el reloj si hace falta.", "a2": "Si solo ves el botón «Instalar», el watchface aún no está instalado." },
                "missingOptions": { "q": "No encuentro una opción de ajuste", "a": "No todas las opciones están disponibles en todos los dispositivos." },
                "naValue": { "q": "Un campo muestra solo «n/a»", "a": "Tu dispositivo no admite esta opción (modelo antiguo o hardware faltante)." }
            }
        },
        "dateFormat": {
            "title": "Formato de fecha personalizado (Fecha 1 / 2 / 3)",
            "basicsTitle": "¿Qué son los campos de formato de fecha?",
            "basicsIntro": "En los ajustes del watchface hay dos campos (o tres) para configurar cómo se muestran Fecha 1, Fecha 2 y opcionalmente Fecha 3. Las letras que introduces definen el formato.",
            "notAll": "No está disponible en todos los watchfaces.",
            "where": "Los campos suelen estar más abajo en los ajustes, bajo las opciones de campos de datos.",
            "codesTitle": "Códigos de formato",
            "codesIntro": "Puedes usar las siguientes letras. El resultado refleja la fecha actual.",
            "codeD": "día del mes (con cero inicial)",
            "codeDText": "día en texto (ej. lunes)",
            "codeM": "mes en número (con cero inicial)",
            "codeMText": "mes en texto",
            "codeY": "año dos dígitos",
            "codeY4": "año cuatro dígitos",
            "codeJ": "fecha juliana (militar)",
            "codeW": "número de semana",
            "codeO": "mes sin cero inicial",
            "codeN": "día sin cero inicial",
            "codeP": "día del año",
            "exampleHint": "Ej.: «D, d.M.Y» puede mostrar «Lun, 27.02.2026»."
        }
    },
    "themeInfo": {
        "howDoThemesWork": {
            "title": "¿Cómo funcionan los temas?",
            "description": "En la parte superior de los ajustes del watchface está el \"themestring\", que representa los colores actuales (iconos, gráfico, hora…). Al cambiar algo y guardar, el themestring se actualiza. Puedes copiarlo para guardar o compartir tus colores (ej. en reseñas/foro) y usar el de otros."
        },
        "dynamicThemeSwitching": {
            "title": "Cambio de tema dinámico",
            "sunset": {
                "title": "Cambiar después del atardecer / antes del amanecer",
                "description": "Pon un ! delante del themestring de destino para que se use tras el atardecer (ej. !UEUE[UEUEEEEEEU^). Para quitarlo, deja solo ! en el campo."
            },
            "lowPower": {
                "title": "Cambiar en modo ahorro",
                "description": "Igual que arriba pero con # delante del themestring (ej. #UEUE[UEUEEEEEEU^). El modo ahorro se activa tras unos 10 s. Ambas opciones se pueden combinar. Guarda el themestring en otro sitio porque deja de verse en los ajustes."
            }
        }
    },
    "helpCenter": {
        "title": "Ayuda e instrucciones",
        "subtitle": "Respuestas, guías e instrucciones para tu watchface",
        "guidesTitle": "Guías e instrucciones",
        "faqTitle": "Preguntas frecuentes",
        "allCategories": "Todo",
        "guides": "Guías",
        "faqResults": "FAQ",
        "noResults": "No se encontraron resultados",
        "noResultsHint": "Prueba otras palabras clave o navega por las categorías y guías de abajo."
    },
    "watchfacesOverview": {
        "title": "Todas las apps",
        "loading": "Cargando watchfaces...",
        "error": "Error al cargar watchfaces",
        "retry": "Intentar de nuevo",
        "noWatchfaces": "No hay watchfaces disponibles"
    },
    "detailTabs": {
        "payment": "Pago",
        "themes": "Temas",
        "info": "Info",
        "instructions": "Instrucciones",
        "instructionsIntro": "Todas las guías e instrucciones de un vistazo:",
        "noThemes": "No hay temas de color disponibles para este watchface."
    },
    "watchfaceDetail": {
        "loading": "Cargando watchface...",
        "error": {
            "notFound": "Watchface no encontrado",
            "loading": "Error al cargar el watchface"
        },
        "backToOverview": "Volver al resumen",
        "goToStore": "Ir al IQ Store",
        "goToTrial": "Versión de prueba",
        "devices": "dispositivos",
        "info": {
            "title": "Características",
            "tides": "🌊 Información de mareas con actualizaciones automáticas",
            "weather": "🌤️ Datos meteorológicos de OpenWeatherMap y Yr",
            "colors": "🎨 Temas de color y personalizaciones",
            "location": "📍 Ubicación por GPS",
            "faq": "❓ FAQ y soporte",
            "weatherFallback": "Sin suscripción One Call 3.0, la clave API OpenWeatherMap usa el proveedor \"Yr\" como respaldo."
        }
    },
    "colorThemes": {
        "clickToCopy": "Clic para copiar",
        "clickToPreview": "Clic para previsualizar",
        "closePreview": "Cerrar previsualización",
        "copied": "¡Copiado!",
        "useInSettings": "Úsalo en la configuración de tu watchface",
        "guideLink": "Más información sobre temas y cadenas de tema",
        "deviceNote": "Los temas de color no están disponibles en todos los dispositivos.",
        "noFieldNote": "Si la configuración de tu watchface no tiene un campo separado para los esquemas de color, estos no son compatibles con tu modelo de reloj en este watchface."
    },
    "payment": {
        "option1": {
            "title": "Opción 1: Garmin Pay",
            "description": "Compra el watchface de pago mediante Garmin Pay en ConnectIQ Store (si tu reloj es compatible).",
            "link": "Enlace al ConnectIQ Store"
        },
        "option2": {
            "title": "Opción 2: Pago directo con WatchfaceID",
            "description": "Si tu reloj no es compatible con la versión Pro, puedes comprar una clave Trial/VX introduciendo tu WatchfaceID.",
            "vxNote": "¡Esta es una clave para la versión VX del watchface, no la versión Garmin Pay!",
            "vxLink": "Enlace a la versión VX"
        },
        "tax": "IVA",
        "wfid": {
            "description": "Introduce tu WatchfaceID (en la configuración del watchface)",
            "placeholder": "Introduce WatchfaceID (5-6 dígitos)",
            "guideLink": "Cómo encontrar tu WatchfaceID",
            "guideLinkShort": "Mostrar instrucciones"
        },
        "wfidError": {
            "letters": "WatchfaceID solo debe contener números",
            "tooLong": "WatchfaceID debe tener 5-6 dígitos",
            "invalid": "Introduce una WatchfaceID válida (5-6 dígitos)",
            "lengthHint": "Una WatchfaceID suele tener 5-6 dígitos. Comprueba."
        },
        "errors": {
            "empty": "Introduce tu WatchfaceID",
            "invalid": "Introduce una WatchfaceID válida",
            "config": "Error de configuración del pago",
            "checkout": "No se pudo abrir el pago. Inténtalo de nuevo."
        },
        "buy": "Comprar ahora",
        "selectMethod": "Elige tu versión",
        "versionSelectHint": "Estas son dos versiones separadas — por favor selecciona la correcta:",
        "vxWarning": "Las versiones VX y Elite son versiones descargables por separado del watchface. Un código de activación para la versión VX NO desbloquea la versión Elite.",
        "beta": {
            "title": "Actualmente en beta",
            "description": "Durante esta fase beta, puedes usar este watchface completamente gratis. No se realizarán cargos automáticos después del período de prueba. En este tiempo se están probando nuevas funciones y mejoras. ¡Gracias por tus comentarios!",
            "descriptionApp": "Durante esta fase beta, puedes usar esta app completamente gratis. Después del periodo de prueba no se aplicarán cargos automáticos. En esta fase se prueban nuevas funciones y mejoras. ¡Gracias por vuestros comentarios!"
        },
        "elite": {
            "badge": "Garmin Pay",
            "title": "Versión Elite",
            "description": "Este watchface está disponible solo mediante Garmin Pay en ConnectIQ Store.",
            "comboDescription": "Compra mediante Garmin Pay en ConnectIQ Store. Versión independiente.",
            "compatibility": "Garmin Pay no es compatible con todos los relojes. Comprueba la compatibilidad en la página Store. Si no, descarga la versión VX (técnicamente idéntica).",
            "storeLink": "Abrir en ConnectIQ Store",
            "moreGuide": "¿Más detalles sobre la diferencia Elite / VX?",
            "moreGuideLink": "Leer la guía de compra e instalación",
            "eliteNoKey": "Al comprar una versión Elite con Garmin Pay no se envía ningún código de desbloqueo. La versión Elite se desbloquea directamente tras la compra y no requiere código.",
            "accountBound": "La compra mediante Garmin Pay está vinculada a tu cuenta Garmin y disponible automáticamente para tus futuros dispositivos (si son compatibles).",
            "eliteNoKeyAndGuide": "Al comprar mediante Garmin Pay no se envía código de desbloqueo — la versión Elite se desbloquea directamente tras la compra. Más detalles en la guía de compra e instalación."
        },
        "vx": {
            "badge": "Todos los dispositivos",
            "title": "Versión VX",
            "description": "Compatible con todos los dispositivos soportados. Descarga la versión de prueba desde ConnectIQ Store y actívala aquí con un código comprado.",
            "trialNote": "La versión VX incluye un período de prueba. Después, compra un código de activación abajo para desbloquearla.",
            "deviceBound": "Un código de activación está vinculado a tu dispositivo y desbloquea la versión VX de forma permanente.",
            "moreGuide": "¿Más detalles sobre la versión VX, las claves o la instalación?",
            "moreGuideLink": "Leer la guía de compra e instalación",
            "downloadLink": "Descargar versión VX",
            "details": {
                "line1": "Tras el pago, la clave de activación se enviará al correo que indiques en el siguiente paso.",
                "line2": "Comprueba que el correo sea correcto.",
                "line3": "Revisa la carpeta de spam tras el pago; los correos con claves suelen llegar ahí.",
                "line4": "Todos los pagos los gestiona Paddle; no hace falta cuenta.",
                "line5": "Para soporte, usa el formulario de contacto o la herramienta ConnectIQ Store.",
                "line6": "Otras consultas no pueden procesarse."
            }
        },
        "standalone": {
            "title": "Comprar código de activación",
            "description": "Compra un código de activación introduciendo tu WatchfaceID abajo. El código te llegará de inmediato."
        },
        "checkoutOpening": "Abriendo pago...",
        "info": {
            "key": "Tras la compra recibirás una clave para introducir en la configuración del watchface.",
            "activation": "La clave se activa justo después del pago.",
            "support": "Si tienes dudas, contacta con soporte.",
            "moreGuide": "Más sobre compra e instalación"
        },
        "methods": {
            "applePay": "Apple Pay",
            "googlePay": "Google Pay",
            "alipay": "Alipay",
            "paypal": "PayPal",
            "creditCard": "Tarjeta de crédito"
        }
    },
    "footer": {
        "tagline": "Apps Garmin modernas con funciones avanzadas para todas las actividades.",
        "description": "Apps Garmin modernas con funciones avanzadas para todas las actividades."
    },
    "newsletter": {
        "title": "Newsletter",
        "description": "Suscríbete al newsletter para novedades sobre esferas, funciones y ofertas.",
        "frequencyHint": "Aproximadamente un correo cada dos meses. Puedes darte de baja en cualquier momento.",
        "emailPlaceholder": "Tu dirección de correo",
        "subscribe": "Suscribirse",
        "unsubscribe": "Darse de baja",
        "subscribeSuccess": "¡Suscripción correcta! Revisa tu correo.",
        "subscribeError": "Ha ocurrido un error. Inténtalo más tarde.",
        "unsubscribeSuccess": "Baja realizada.",
        "unsubscribeError": "Ha ocurrido un error. Inténtalo más tarde."
    },
    "contact": {
        "title": "Contacto",
        "description": "¿Tienes alguna pregunta o necesitas ayuda? Envíame un mensaje.",
        "emailLabel": "Correo electrónico",
        "emailPlaceholder": "tu@email.es",
        "deviceLabel": "Dispositivo (opcional)",
        "devicePlaceholder": "p. ej. Fenix 7",
        "watchfaceLabel": "Watchface (opcional)",
        "watchfacePlaceholder": "p. ej. Horizon",
        "messageLabel": "Mensaje",
        "messagePlaceholder": "Tu mensaje...",
        "send": "Enviar mensaje",
        "sendAnother": "Enviar otro mensaje",
        "successTitle": "¡Mensaje enviado!",
        "successMessage": "Te responderé lo antes posible.",
        "error": "Ha ocurrido un error. Inténtalo de nuevo o escribe directamente a dev@orcatec.net.",
        "rateLimit": "Máximo 2 mensajes cada 5 minutos. Inténtalo más tarde.",
        "consentNotice": "Al enviar aceptas el tratamiento de tus datos de acuerdo con mi",
        "guidesIntro": "Si tienes preguntas sobre funciones concretas, puede que estas guías ya tengan la respuesta:",
        "faqIntro": "Para muchos temas también hay una FAQ detallada:",
        "faqLinkLabel": "Abrir Ayuda e Instrucciones",
        "responseTimeNotice": "Ten en cuenta que en épocas con mucho volumen de trabajo una respuesta puede tardar varios días."
    },
    "fonts": {
        "title": "Fuentes",
        "timefonts": "Fuentes de hora",
        "datafonts": "Fuentes de datos"
    },
    "common": {
        "loading": "Cargando...",
        "error": "Error",
        "retry": "Intentar de nuevo",
        "back": "Atrás",
        "close": "Cerrar",
        "save": "Guardar",
        "cancel": "Cancelar",
        "confirm": "Confirmar",
        "notFound": "404 – Página no encontrada"
    },
    "bierwander": {
        "title": "Bierwandern",
        "intro": "La app Bierwandern te permite registrar tu caminata y las recargas que disfrutas en el camino. Además, incluye una estimación de promile con gráfico (estimación aproximada) – ¡pero no te la tomes demasiado en serio!",
        "settingsHint": "En la pantalla de inicio, pulsa el botón de menú de tu reloj para abrir los ajustes (en relojes con diseño de 2 botones, mantén pulsada la pantalla táctil).",
        "disclaimer": "El cálculo de promile es una métrica puramente divertida: un algoritmo que estima el alcohol en sangre según las bebidas consumidas y el peso corporal. ¡No tomes decisiones basándote en este valor; no es fiable ni constituye una medición real del alcohol!",
        "closing": "Por lo demás, ¡te deseo buenas caminatas y que lo pases bien!",
        "support": "Para problemas o sugerencias de mejora, usa el botón «App Support» – gracias."
    },
    "bodysurf": {
        "intro": {
            "title": "¿Qué es BodySurf?",
            "text": "BodySurf es una app Garmin Connect IQ para bodysurf. Usa el GPS para detectar cuándo surfeas una ola, mide distancia y duración de cada ride y asigna un título divertido según la distancia. Las sesiones se guardan como actividades con vueltas individuales en Garmin Connect."
        },
        "gps": {
            "title": "Antes de empezar – GPS",
            "text1": "Espera al fix GPS antes de iniciar una sesión. En la pantalla de inicio verás \"Buscando GPS\" hasta tener señal, luego \"INICIAR para comenzar\".",
            "text2": "Para mayor precisión la app usa GPS multi-GNSS / doble banda si tu reloj lo soporta. Quédate quieto un momento junto al agua si el fix tarda."
        },
        "start": {
            "title": "Pantalla de Inicio",
            "startBtn": "Inicia una nueva sesión cuando el GPS esté listo (INICIAR = comenzar sesión).",
            "menuBtn": "Abre ajustes: Cómo usar y Unidades (MENÚ = configuraciones / info).",
            "backBtn": "ATRÁS = salir de la app"
        },
        "during": {
            "title": "Durante la Actividad",
            "detect": "Los montajes son detectados por GPS velocidad automáticamente. Usa ATRÁS para iniciar/detener un montaje manualmente. Los movimientos cortos de menos de 2 metros se descartan.",
            "startBtn": "INICIAR = detener / guardar / reanudar",
            "backBtn": "ATRÁS = montar manualmente encendido/apagado",
            "live": "Mientras surfeas ves la distancia actual, un título en vivo y \"¡MONTANDO!\". Tras un ride el título y las estadísticas permanecen hasta el siguiente."
        },
        "stop": {
            "title": "Menú de parada",
            "resume": "Reanudar",
            "save": "Guardar",
            "discard": "Descartar"
        },
        "after": {
            "title": "Después de la Sesión",
            "summary": "El resumen muestra tiempo de sesión, número de Montajes, distancia total y tu ride Mejor con título y estadísticas.",
            "rides": "Desliza para ver detalles del montaje. En relojes con botones: << DOWN rides.",
            "finished": "Después: Nueva Sesión con START o Salir de la App con ATRÁS."
        },
        "titles": {
            "title": "Títulos de ride",
            "intro": "Cada montaje recibe un título divertido basado en la distancia. Cuanto más largo sea el montaje, ¡mejor será el título!",
            "colDistance": "Distancia",
            "colTitle": "Título",
            "th0": "Resto de playa",
            "th1": "Pepino de mar",
            "th2": "Platija",
            "th3": "Espantagaviotas",
            "th4": "Sheriff costero",
            "th5": "Inspector de olas",
            "th6": "Jinete de olas",
            "th7": "Asesor de corrientes",
            "th8": "Rompeolas",
            "th9": "Aquaman",
            "th10": "Tabla de surf humana",
            "th11": "Leyenda costera",
            "th12": "Poseidón"
        },
        "connect": {
            "title": "Garmin Connect",
            "text": "Las sesiones guardadas aparecen en Garmin Connect con campos personalizados: título de ride, distancia de vuelta (metros), tiempo de vuelta (segundos) y ride/tiempo más largos a nivel de sesión. Cada ride detectado se guarda como vuelta."
        },
        "instinct": {
            "title": "Instinct 2 / 3 (MIP)",
            "layout": "En Instinct el subdisplay muestra hora, GPS y distancia. Usa el botón ABAJO en lugar de deslizar (<< DOWN rides).",
            "menu": "\"Menú\" aparece a la izquierda en la pantalla de inicio. Presiona INICIAR cuando GPS OK aparece en el subdisplay."
        },
        "settings": {
            "title": "Ajustes",
            "units": "Unidades: cambia entre métrico e imperial para distancia y velocidad en el reloj.",
            "info": "Info: ayuda integrada (Cómo usar) para botones durante actividad, tras sesión y pantalla de inicio."
        },
        "supportBefore": "Para problemas o sugerencias usa el",
        "supportLink": "formulario de contacto",
        "supportAfter": " – ¡gracias!"
    }
};
